import { writable, derived } from "svelte/store";
import data from "./index.js";

let { companies } = data;

export const filterExpanded = writable(false);
export const selectedCategoryOne = writable("");
export const selectedCategoryTwo = writable("");

export const filteredCompanies = derived(
  [selectedCategoryOne, selectedCategoryTwo],
  ([$selectedCategoryOne, $selectedCategoryTwo]) => {
    return companies.filter((company) => {
      let one = true;
      let two = true;
      if ($selectedCategoryOne) {
        one = company.categoryList.includes($selectedCategoryOne);
      }
      if ($selectedCategoryTwo) {
        two = company.categoryList.includes($selectedCategoryTwo);
      }
      return one && two;
    });
  }
);

export const secondaryCategories = derived(
  [filterExpanded, selectedCategoryOne, filteredCompanies],
  ([$filterExpanded, $selectedCategoryOne, $filteredCompanies]) => {
    if ($filterExpanded && $selectedCategoryOne) {
      return $filteredCompanies.reduce(
        (accumulator, currentValue) => {
          currentValue.categoryList
            .filter((elem) => elem.length > 1)
            .filter((elem) => elem !== $selectedCategoryOne)
            .forEach((elem) => {
              if (!accumulator.includes(elem)) {
                accumulator.push(elem);
              }
            });
          return accumulator;
        },

        []
      );
    }
    return [];
  }
);
